import React from 'react';
import { Redirect } from 'react-router-dom';

const Reports = () => {
	return <Redirect to="/admin/reports/messages" />
}

export default Reports;